// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookademopopupbox {
  max-width: 500px;
  margin: 0 auto;
  padding-top: 100px;
  z-index: 0;
  position: relative;
}

.bookademopopupbox h4 {
  color: #000;
  font-size: 24px;
  text-align: center;
}

.bookademopopupbox p {
  font-size: 20px;
  margin-bottom: 15px;
  color: #000;
  text-align: center;
}

.bookademopopupbox figure {
  text-align: center;
}

.bookademopopup .modal-content img {
  text-align: center;
  margin: 0 auto;
  margin-bottom: 15px;
}

.bookademopopupbox input[type=text], .bookademopopupbox input[type=email], .bookademopopupbox input[type=number], .bookademopopupbox textarea {
  color: #121111;
  outline: none;
  border-radius: 4px;
  position: relative;
  z-index: 99;
  box-shadow: none;
  margin: 0;
  margin-bottom: 20px;
  padding: 10px 15px !important;
  font-size: 18px !important;
}

.bookademopopupbox button {
  width: 100%;
  background-color: #ff9900;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  font-size: 18px;
  padding: 12px;
}

.bookademopopupbox button:hover {
  background: #ec8f04;
}

.bookademo_formbox span.textValidatorError {
  margin-bottom: 10px;
  position: relative;
  display: flex;
}

@media (max-width: 767px) {
  .bookademopopupbox {
    width: 100%;
    max-width: 100%;
    padding: 100px 15px 0 15px;
  }
}
.contact_header {
  margin: 0;
  padding: 0 15px;
}

.contact_header_container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 15px 0;
  background-color: #fafafa;
}

.contact_header_logo {
  width: 20%;
}

.contact_header_logo img {
  width: 120px;
}

.contact_header_heading {
  width: 80%;
  font-size: 28px;
  font-weight: 700;
  color: #282828;
  text-align: center;
}

.sign_in_btn {
  width: 100%;
  background-color: #0a6ebe;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  font-size: 18px;
  padding: 12px;
  display: block;
  text-align: center;
  margin-top: 15px;
}

.sign_in_btn:hover {
  background-color: #055596;
  color: #FFF;
}

@media (max-width: 767px) {
  .contact_header_heading {
    text-align: right;
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/contactus.scss"],"names":[],"mappings":"AAEA;EACI,gBAAA;EAAiB,cAAA;EAAe,kBAAA;EAAmB,UAAA;EAAW,kBAAA;AAGlE;;AADA;EAAsB,WAAA;EAAY,eAAA;EAAgB,kBAAA;AAOlD;;AANA;EAAqB,eAAA;EAAgB,mBAAA;EAAoB,WAAA;EAAW,kBAAA;AAapE;;AAZA;EAA0B,kBAAA;AAgB1B;;AAfA;EAAmC,kBAAA;EAAmB,cAAA;EAAe,mBAAA;AAqBrE;;AAnBA;EAA2I,cAAA;EAAe,aAAA;EAAc,kBAAA;EAAmB,kBAAA;EAAmB,WAAA;EAAY,gBAAA;EAAiB,SAAA;EAAU,mBAAA;EAAoB,6BAAA;EAA8B,0BAAA;AAgCvS;;AA/BA;EAA0B,WAAA;EAAY,yBAAA;EAA0B,YAAA;EAAa,kBAAA;EAAmB,cAAA;EAAe,eAAA;EAAgB,aAAA;AAyC/H;;AAxCA;EAAgC,mBAAA;AA4ChC;;AA3CA;EAA2C,mBAAA;EAAoB,kBAAA;EAAmB,aAAA;AAiDlF;;AA/CA;EACI;IACI,WAAA;IACA,eAAA;IACA,0BAAA;EAkDN;AACF;AA/CA;EAAgB,SAAA;EAAU,eAAA;AAmD1B;;AAlDA;EAA0B,aAAA;EAAc,mBAAA;EAAoB,2BAAA;EAA4B,eAAA;EAAgB,yBAAA;AA0DxG;;AAzDA;EAAqB,UAAA;AA6DrB;;AA5DA;EAAyB,YAAA;AAgEzB;;AA/DA;EAAwB,UAAA;EAAW,eAAA;EAAgB,gBAAA;EAAiB,cAAA;EAAe,kBAAA;AAuEnF;;AArEA;EAAa,WAAA;EAAY,yBAAA;EAA0B,YAAA;EAAa,kBAAA;EAAmB,cAAA;EAAe,eAAA;EAAgB,aAAA;EAAc,cAAA;EAAe,kBAAA;EAAmB,gBAAA;AAkFlK;;AAjFA;EAAmB,yBAAA;EAA0B,WAAA;AAsF7C;;AApFA;EACI;IACI,iBAAA;IACA,eAAA;EAuFN;AACF","sourcesContent":["$mobileBig: 767px;\r\n\r\n.bookademopopupbox{\r\n    max-width: 500px;margin: 0 auto;padding-top: 100px;z-index: 0;position: relative;\r\n}\r\n.bookademopopupbox h4{color: #000;font-size: 24px;text-align: center;}\r\n.bookademopopupbox p{font-size: 20px;margin-bottom: 15px;color:#000;text-align: center;}\r\n.bookademopopupbox figure{text-align: center;}\r\n.bookademopopup .modal-content img{text-align: center;margin: 0 auto;margin-bottom: 15px;}\r\n\r\n.bookademopopupbox input[type=text],.bookademopopupbox input[type=email],.bookademopopupbox input[type=number],.bookademopopupbox textarea{color: #121111;outline: none;border-radius: 4px;position: relative;z-index: 99;box-shadow: none;margin: 0;margin-bottom: 20px;padding: 10px 15px !important;font-size: 18px !important}\r\n.bookademopopupbox button{width: 100%;background-color: #ff9900;border: none;border-radius: 4px;color: #ffffff;font-size: 18px;padding: 12px;}\r\n.bookademopopupbox button:hover{background: #ec8f04;}\r\n.bookademo_formbox span.textValidatorError{margin-bottom: 10px;position: relative;display: flex;}\r\n\r\n@media (max-width: $mobileBig) {\r\n    .bookademopopupbox{\r\n        width: 100%;\r\n        max-width: 100%;\r\n        padding: 100px 15px 0 15px;\r\n    } \r\n}\r\n\r\n.contact_header{margin: 0;padding: 0 15px;}\r\n.contact_header_container{display: flex;align-items: center;justify-content: flex-start;padding: 15px 0;background-color: #fafafa;}\r\n.contact_header_logo{width: 20%;}\r\n.contact_header_logo img{width: 120px;}\r\n.contact_header_heading{width: 80%;font-size: 28px;font-weight: 700;color: #282828;text-align: center;}\r\n\r\n.sign_in_btn{width: 100%;background-color: #0a6ebe;border: none;border-radius: 4px;color: #ffffff;font-size: 18px;padding: 12px;display: block;text-align: center;margin-top: 15px;}\r\n.sign_in_btn:hover{background-color: #055596;color: #FFF;}\r\n\r\n@media (max-width: $mobileBig) {\r\n    .contact_header_heading{\r\n        text-align: right;\r\n        font-size: 18px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
